module.exports = "/assets/landing-korw/how-it-works/step_3@2x.png?zwj5RbU";